<template>
  <div class="cadfm-container-horizontal">



            <Main v-show="$route.params.view == 'Main'"
             :lang="lang.About.Main"></Main>

 </div>
</template>

<script>


import Main from '@/components/About/Views/Main'


//import Left from '@/components/PartManager/Left/Left'
//import Right from '@/components/PartManager/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'About',
  components:{
    Main,

  },
  props: {
    lang: Object
  },
  data () {
    return {
      sectionPrefix: "set",
      basicView: "Main",
    }
  },
  beforeRouteUpdate (to, from, next) {
    
    
  },
  computed: {
    
   

  },
  watch: {

  },
  beforeCreate () {
    
    this.$store.dispatch("setView", "Main");
  },
  created() {
    this.$store.dispatch("showLoader", { visible: false, text: "" });
    this.$store.dispatch("setSectionPrefix", this.sectionPrefix)
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/About/About.vue